import { defineStore } from 'pinia'

export const useToolsStore = defineStore('tools', () => {
  const analyticsFirstSuccessInit = ref(false)
  const clarityReady = ref(false)
  const metaPixelReady = ref(false)

  const setAnalyticsFirstSuccessInit = (payload: boolean): void => {
    analyticsFirstSuccessInit.value = payload
  }
  const setClarityReady = (payload: boolean): void => {
    clarityReady.value = payload
  }
  const setMetaPixelReady = (payload: boolean): void => {
    metaPixelReady.value = payload
  }

  const reset = (): void => {
    analyticsFirstSuccessInit.value = false
    clarityReady.value = false
    metaPixelReady.value = false
  }

  return {
    analyticsFirstSuccessInit,
    clarityReady,
    metaPixelReady,
    setAnalyticsFirstSuccessInit,
    setClarityReady,
    setMetaPixelReady,
    reset,
  }
})
